export default __webpack_public_path__ + "fe526d22c7d5be30a674664151f421a0.svg";